import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactTextfield from 'shared/design-system/components/TrueImpactTextfield';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

interface PaginationPageInfoProps {
  currentPage: number;
  totalPages: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${SPACERS.small};
  & * {
    font-size: 14px;
  }
  input {
    padding: 4px;
    max-width: 40px;
    text-align: center;
    margin-right: ${SPACERS.extraTiny};
  }
`;

const PaginationPageInfo: React.FC<PaginationPageInfoProps> = ({
  currentPage,
  totalPages,
  setPage,
}) => {
  const [text, setText] = useState<string | number>(currentPage);

  useEffect(() => {
    setText(currentPage);
  }, [currentPage]);

  const handleBlur = useCallback(() => {
    let value = Number(text);
    if (!text || (!value && value !== 0)) {
      setText(currentPage.toString());
      return;
    }
    value = value < 1 ? 1 : value > totalPages ? totalPages : value;
    setText(value);
    setPage(value - 1);
  }, [text, currentPage]);

  return (
    <StyledDiv>
      <TrueImpactTextfield
        placeholder="Page"
        value={text}
        onChange={setText}
        onBlur={handleBlur}
      />
      <TrueImpactText> of {totalPages}</TrueImpactText>
    </StyledDiv>
  );
};

export default PaginationPageInfo;
